import { EFilterEventName } from './../../enum';
import styles from './index.module.less';
import template from './index.art';
import { IOYFlagProps, IOYFlagState ,IStockFlag} from './const';
import OY from '../../../../types/OY';
import { jeact } from '../../../../decorators/jeact';
import { StockFlagType } from './enum';

@jeact({ autoRender: true })
export default class OYFlag extends OY<IOYFlagProps, IOYFlagState> {
  static displayName = 'OYFlag';

  static defaultProps: Partial<IOYFlagProps> = {}

  public state: IOYFlagState = {
    icon: {
      // 1: `<svg class="icon oy_filter_flag_svg_icon _tooltip_" aria-hidden="true" data-width="250" data-placement="top" data-toggle="tooltip" title="" data-original-title="指经欧冶云商验证，牌号与钢厂的原厂资源信息一致。"> <use xlink:href="#icon-bao"></use></svg>`,
      // 3: `<svg class="icon oy_filter_flag_svg_icon _tooltip_" aria-hidden="true" data-width="250" data-placement="top" data-toggle="tooltip" title="" data-original-title="指经欧冶云商验证，牌号与钢厂的原厂资源信息不一致。"> <use xlink:href="#icon-shen"></use></svg>`,
      // 4: `<svg class="icon oy_filter_flag_svg_icon _tooltip_" aria-hidden="true" data-width="250" data-placement="top" data-toggle="tooltip" title="" data-original-title="指经欧冶云商验证，牌号等关键信息与钢厂的原厂资源信息完全一致，可放心购买。"><use href="#icon-jinyin"></use></svg>`,
      // 11: '<svg class="icon oy_filter_flag_svg_icon _tooltip_" aria-hidden="true" data-width="250" data-placement="top" data-toggle="tooltip" title="" data-original-title="经认证，该资源在仓库系统信息完全符合，可放心购买"><use xlink:href="#icon-denglv"></use></svg>',
      // 12: '<svg class="icon oy_filter_flag_svg_icon _tooltip_" aria-hidden="true" data-width="250" data-placement="top" data-toggle="tooltip" title="" data-original-title="可信供应商资源，该资源所在仓库暂不具备网上验证能力"><use xlink:href="#icon-denglan"></use></svg>',
      // 13: '<span style="width: 36px;height: 20px;float: left;overflow:hidden;"><svg class="icon oy_filter_flag_svg_icon _tooltip_" aria-hidden="true" style="position: relative;bottom: 8px;width:1em;height:1em;font-size:36px !important;" data-width="250" data-placement="top" data-toggle="tooltip" data-original-title="经认证，该资源真实在库，购买后请等待供应商过户，超时未转绿的订单自动撤销。"><use xlink:href="#icon-dengrongzi"></use></svg></span>',
      // 21: '<svg class="icon oy_filter_flag_svg_icon _tooltip_" aria-hidden="true" data-width="250" data-placement="top" data-toggle="tooltip" title="" data-original-title="经认证，该资源真实在库，但货主信息不符，购买后需等待供应商过户，2天后未转绿的订单自动撤销"><use xlink:href="#icon-denghuang"></use></svg>',
      // 22: '<svg class="icon oy_filter_flag_svg_icon _tooltip_" aria-hidden="true" data-width="250" data-placement="top" data-toggle="tooltip" title="" data-original-title="钢厂直销期货资源"><use xlink:href="#icon-dengzi"></use></svg>',
      // 31: '<svg class="icon oy_filter_flag_svg_icon _tooltip_" aria-hidden="true" data-width="250" data-placement="top" data-toggle="tooltip" title="" data-original-title="该资源所在仓库暂不具备网上验证能力，仅支持撮合交易"><use xlink:href="#icon-dengbai"></use></svg>',
      // 32: '<svg class="icon oy_filter_flag_svg_icon _tooltip_" aria-hidden="true" data-width="250" data-placement="top" data-toggle="tooltip" title="" data-original-title="经验证，该资源卖家上传信息与仓库信息不符合，暂不支持购买。"><use xlink:href="#icon-denghong"></use></svg>',
      // 91: '<svg class="icon oy_filter_flag_svg_icon _tooltip_" aria-hidden="true" data-width="250" data-placement="top" data-toggle="tooltip" title="" data-original-title="经验证，该资源卖家上传信息与仓库信息不符合，暂不支持购买"><use xlink:href="#icon-denghei"></use></svg>',

      picture: '<i class="icon iconfont font16 blue">&#xe672;</i>',
      video: '<i class="icon iconfont font24 blue">&#xe677;</i>'
    }
  };

  $node = {}

  getDerivedStateFromProps(nextProps: IOYFlagProps, state: IOYFlagState): IOYFlagState {
    const flags = this.getIcon(nextProps.info)
    
    return {
      ...state,
      icon: {
        ...state.icon,
        ...flags
      }
    }
  }

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  renderCheckbox() {
    this.$el.find('oy-checkbox').each((_in, element) => {
      const $element = $(element);
      const key: 'stockFlag' | 'qualityFlag' = $element.data('key');
      const data = this.props.info[key]
      const value = this.props.value[key];
      const checkbox = $element.OYCheckbox({
        ...data,
        value,
        renderItem: (itemData: any) => {
          return this.state.icon[itemData.value as any]
        },
        onChange: (cvalue: string[]) => {
          this.eventEmitter.emit(EFilterEventName.OnChange, cvalue, key)
          setTimeout(() => {
            this.eventEmitter.emit(EFilterEventName.onSearch)
          })
        }
      })

      const $icon = checkbox.$el.find('.oy_filter_flag_svg_icon');
      $icon
        .parents('span.oy_chekcbox_itemSpan')
        .css({
          'overflow': 'auto',
          'white-space': 'normal'
        });
      
    })
  }

  private getIcon (info: any) {
    let iconList: IStockFlag[] = []
    let iconObj:{
      [i: string]: string
    } = {};

    //遍历flag字段下的info，将info中每个字段下的info数组里的对象取出放入iconList中
    for(let obj in info ){
      info[obj].info.length && info[obj].info.forEach((item:IStockFlag) => {
        iconList.push(item)
      });
    }
    //遍历iconList数组，将每项value作为key值，组装成新的flag浮窗配置内容
    iconList.forEach(i =>{
      if(i.value == '13'){ // dengrongzi特殊样式，单独处理
        iconObj = Object.assign(iconObj,{
          [i.value]:`<span style="width: 36px;height: 20px;float: left;overflow:hidden;"><svg class="icon oy_filter_flag_svg_icon _tooltip_" aria-hidden="true" style="position: relative;bottom: 8px;width:1em;height:1em;font-size:36px !important;"  data-placement="top" data-container="body" data-widthlimit="250px" data-toggle="${ i.tooltip ? 'tooltip' : null}" data-original-title="${i.tooltip || ''}"><use xlink:href="#icon-dengrongzi"></use></svg></span>`
        }) 
      }else {
        iconObj = Object.assign(iconObj,{
          [i.value]:`<svg class="icon oy_filter_flag_svg_icon _tooltip_" aria-hidden="true" data-container="body" data-widthlimit="250px" data-placement="top"  data-toggle="${ i.tooltip ? 'tooltip' : null}" title="" data-original-title="${i.tooltip || ''}"> <use xlink:href="${StockFlagType[i.value]}"></use></svg>`
        }) 
      }
    })
    return iconObj
  }

  setNode(): void { }
}



// WEBPACK FOOTER //
// ./src/components/OYFilter/components/OYFlag/index.ts